import React, {useEffect, useState} from 'react';
import {DEFAULT_PAGE_SIZE, LOCAL_STORAGE_USER_LOGIN_INFO} from '@app/constants/Common';
import QuickSearchJob from "@pages/job/list/QuickSearchJob";
import OrderListByUpdatedTime from "@app/components/OrderListByUpdatedTime";
import RunJobMainModal from "@pages/job/runjob/RunJobMainModal";

const JobListTable = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [numberPages, setNumberPages] = useState(1);
    const [jobList, setJobList] = useState([]);
    const [searchCondition, setSearchCondition] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [showRunJobModal, setShowRunJobModal] = useState(false);
    const [selectJob, setSelectJob] = useState({});

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    const {jobs} = props
    const {totalCount} = props
    const {onSearch} = props

    const nextPage = () => {
        let currPage = currentPage + 1
        if (currPage <= numberPages) {
            searchCondition.page = currPage
            onSearch(searchCondition)
        } else {
            currPage = numberPages
        }
        setCurrentPage(currPage)
    };

    const onSearchClick = (condition) => {
        if (!condition.page) {
            condition.page = currentPage
        }

        condition.size = DEFAULT_PAGE_SIZE
        setSearchCondition(condition)
        return onSearch(condition)
    };

    const backPage = () => {
        let currPage = currentPage - 1
        if (currPage > 0) {
            searchCondition.page = currPage
            onSearch(searchCondition)
        } else {
            currPage = 0
        }
        setCurrentPage(currPage)
    };

    useEffect(() => {
        setJobList([...jobs])
    }, [jobs])

    useEffect(() => {
        setNumberPages(Math.ceil(totalCount/DEFAULT_PAGE_SIZE))
    }, [totalCount])

    const openJobDetail = (jobId) => {
        if (!jobId) {
            jobId = jobList[0].id
        }
        const win = window.open(`/job/edit/${jobId}`, "_blank");
        win.focus();
    }
    const openRunJobModal = (job) => {
        setSelectJob({...job})
        setShowRunJobModal(true)
    }

    return (
        <>
            <QuickSearchJob onSearch={(condition) => onSearchClick(condition)}/>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Danh sách Job ({totalCount})</h3>
                    {totalCount > 0 &&
                    <h3 className='card-title text-bold ml-3'>Page: {currentPage}/{numberPages}</h3>
                    }
                    <div className='card-tools'>
                        <OrderListByUpdatedTime onChange={(orderBy) => {
                            searchCondition.order_by = orderBy
                            onSearch(searchCondition)
                        }}/>
                        {numberPages > 1 &&
                        <ul className='pagination pagination-sm float-right mt-2 ml-5'>
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                        onClick={() => backPage()}>&laquo;</button>
                            </li>
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                        onClick={() => nextPage()}>&raquo;</button>
                            </li>
                        </ul>
                        }
                    </div>
                </div>
                <div className='card-body table-responsive p-0' style={{minHeight: 300}}>
                    <table
                        className='table table-hover table-bordered text-nowrap text-center'
                    >
                        <thead>
                        <tr>
                            <th>No.</th>
                            <th>Job ID</th>
                            {userLoginInfo.is_superuser &&
                            <th>Loại Dịch vụ</th>
                            }
                            <th>Employer Name (brief)</th>
                            <th>Job Title</th>
                            <th>Job Status</th>
                            <th>Location (Tỉnh)</th>
                            <th>Lương tối thiểu (trđ)</th>
                            <th>Lương tối đa (trđ)</th>
                            <th>Job date</th>
                            <th>Hành động</th>
                        </tr>
                        </thead>
                        <tbody>
                        {jobList && jobList.length > 0 && jobList.map((job, index) => (
                            <tr key={`job_${index}`}>
                                <td>{job.no ? job.no : index + 1}</td>
                                <td>
                                    <a href="javascript:void(0)" onClick={() => openJobDetail(job.id)}>
                                        {job.id}
                                    </a>
                                </td>
                                {userLoginInfo.is_superuser &&
                                    <td>{job.service_type}</td>
                                }
                                <td>
                                    {job.employer_brief_name}
                                </td>
                                <td>{job.job_title}</td>
                                <td>{job.job_status}</td>
                                <td>{job.local_province}</td>
                                <td>{job.min_salary}</td>
                                <td>{job.max_salary}</td>
                                <td>{job.created_date_time}</td>
                                <td>
                                    <div className="btn-group">
                                        <button type={"button"} onClick={() => openRunJobModal(job)} className={"btn btn-default"}>Run job</button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <div className='card-footer'>
                    <div className='card-tools'>
                        {numberPages > 1 &&
                        <ul className='pagination pagination-sm float-right'>
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                        onClick={() => backPage()}>&laquo;</button>
                            </li>
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                        onClick={() => nextPage()}>&raquo;</button>
                            </li>
                        </ul>
                        }
                    </div>
                </div>
            </div>

            {showRunJobModal &&
            <RunJobMainModal candidateIds={[]}
                             jobId={selectJob.id}
                             onClose={() => setShowRunJobModal(false)}
                             isShow={showRunJobModal}/>
            }
        </>
    );
};

export default JobListTable;
